import { render, staticRenderFns } from "./KYCForm.vue?vue&type=template&id=2d2491f2"
import script from "./KYCForm.vue?vue&type=script&lang=js"
export * from "./KYCForm.vue?vue&type=script&lang=js"
import style0 from "./KYCForm.vue?vue&type=style&index=0&id=2d2491f2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports